export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },
    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"), //导航
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [

        /* 欢迎页*/
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/view/management/welcome/index.vue"),
        },

        /* 系统管理 */
        {
          path: "system",
          component: () =>
            import("@/view/management/system/index.vue"), //导航
          children: [{
            path: "user",
            name: "SysUser",
            component: () =>
              import("@/view/management/system/user/index.vue"),
          },
          {
            path: "accountMapping",
            name: "AccountMapping",
            component: () =>
              import("@/view/management/system/accountMapping/index.vue"),
          },
          {
            path: "authGroup",
            name: "AuthGroup",
            component: () =>
              import(
                "@/view/management/system/authGroup/index.vue"
              ),
          },
          {
            path: "menu",
            name: "Menu",
            component: () =>
              import("@/view/management/system/menu/index.vue"),
          },
          {
            path: "log",
            name: "Log",
            component: () =>
              import("@/view/management/system/log/index.vue"),
          },
          ],
        },
        //商家-管理账号权限
        {
          path: "myPermission",
          name: "MyPermission",
          component: () => import("@/view/management/myPermission/index.vue"),
          children: [{
            path: "user",
            name: "MyPermissionUser",
            component: () =>
              import("@/view/management/myPermission/user/index.vue"),
          },
          {
            path: "authGroup",
            name: "MyPermissionAuthGroup",
            component: () =>
              import("@/view/management/myPermission/authGroup/index.vue"),
          },
          ],
        },



        /* 小程序管理 */
        {
          path: "miniApp",
          component: () => import("@/view/management/miniApp/index.vue"), //导航
          children: [
            /* 首页-数据面板 */
            {
              path: "dashboard",
              name: "Dashboard",
              component: () => import("@/view/management/miniApp/dashboard"),
            },
            {
              path: "user",
              name: "MallUser",
              component: () =>
                import("@/view/management/miniApp/user/index.vue"),
            },
            {
              path: "store",
              name: "MallStore",
              component: () =>
                import("@/view/management/miniApp/store/index.vue"),
            },
            {
              path: "banner",
              name: "MiniAppBanner",
              component: () =>
                import("@/view/management/miniApp/banner/index.vue"),
            },
            {
              path: "article",
              name: "MiniAppArticle",
              component: () =>
                import("@/view/management/miniApp/article/index.vue"),
            }
          ]
        },
        {
          path: "fairInfo",
          name: "FairInfo",
          component: () =>
            import("@/view/management/fairInfo/index.vue"),
        },
        /* 门店管理 */
        // {
        //   path: "store",
        //   name: "Store",
        //   component: () => import("@/view/management/store/index.vue"),
        //   children: [{
        //     path: "storeList",
        //     name: "StoreList",
        //     component: () =>
        //       import("@/view/management/store/storeList/index.vue"),
        //   },
        //   {
        //     path: "staff",
        //     name: "Staff",
        //     component: () =>
        //       import("@/view/management/store/staff/index.vue"),
        //   },
        //   {
        //     path: "coupon",
        //     name: "Coupon",
        //     component: () =>
        //       import("@/view/management/store/coupon/index.vue"),
        //   },
        //   {
        //     path: "goods",
        //     name: "Goods",
        //     component: () =>
        //       import("@/view/management/store/goods/index.vue"),
        //     children: [{
        //       path: "goodsKind",
        //       name: "GoodsKind",
        //       component: () =>
        //         import("@/view/management/store/goods/goodsKind/index.vue"),
        //     },
        //     {
        //       path: "goodsList",
        //       name: "GoodsList",
        //       component: () =>
        //         import("@/view/management/store/goods/goodsList/index.vue"),
        //     },
        //     ],
        //   },
        //   {
        //     path: "mallGoods",
        //     name: "MallGoods",
        //     component: () =>
        //       import("@/view/management/store/mallGoods/index.vue"),
        //     children: [{
        //       path: "goodsKind",
        //       name: "MallGoodsKind",
        //       component: () =>
        //         import(
        //           "@/view/management/store/mallGoods/goodsKind/index.vue"
        //         ),
        //     },
        //     {
        //       path: "goodsList",
        //       name: "MallGoodsList",
        //       component: () =>
        //         import(
        //           "@/view/management/store/mallGoods/goodsList/index.vue"
        //         ),
        //     },
        //     ],
        //   },
        //   {
        //     path: "integralGoods",
        //     name: "IntegralGoods",
        //     component: () =>
        //       import("@/view/management/store/integralGoods/index.vue"),
        //     children: [{
        //       path: "goodsKind",
        //       name: "IntegralGoodsKind",
        //       component: () =>
        //         import(
        //           "@/view/management/store/integralGoods/goodsKind/index.vue"
        //         ),
        //     },
        //     {
        //       path: "goodsList",
        //       name: "IntegralGoodsList",
        //       component: () =>
        //         import(
        //           "@/view/management/store/integralGoods/goodsList/index.vue"
        //         ),
        //     },
        //     ],
        //   },

        //   /* 门店会员订单 */
        //   {
        //     path: "order",
        //     name: "Order",
        //     component: () => import("@/view/management/store/order/index.vue"),
        //   },

        //   ],
        // },

        /* 信息概览 */
        {
          path: "information",
          component: () => import("@/view/management/information/index.vue"),
          children: [
            //问答流程配置
            {
              path: "list",
              name: "InformationList",
              component: () =>
                import("@/view/management/information/list/index.vue"),
            },
            //线索表单参数模版配置
            {
              path: "reservation",
              name: "InformationReservation",
              component: () =>
                import("@/view/management/information/reservation/index.vue"),
            },
          ],
        },

        /* 提示词管理 */
        {
          path: "promptService",
          component: () => import("@/view/management/promptService/index.vue"),
          children: [
            //问答流程配置
            {
              path: "questions_one",
              name: "PromptQuestions_one",
              component: () =>
                import("@/view/management/promptService/questions_one/index.vue"),
            },
            {
              path: "questions_two",
              name: "PromptQuestions_two",
              component: () =>
                import("@/view/management/promptService/questions_two/index.vue"),
            },
            {
              path: "questions_three",
              name: "PromptQuestions_three",
              component: () =>
                import("@/view/management/promptService/questions_three/index.vue"),
            },
            //线索表单参数模版配置
            {
              path: "archives",
              name: "PromptArchives",
              component: () =>
                import("@/view/management/promptService/archives/index.vue"),
            },
          ],
        },

        /* 提示词管理 */
        {
          path: "aiService",
          component: () => import("@/view/management/aiService/index.vue"),
          children: [
            {
              path: "robot",
              name: "Robot",
              component: () =>
                import("@/view/management/aiService/robot/index.vue"),
            },
            {
              path: "skill",
              name: "Skill",
              component: () =>
                import("@/view/management/aiService/skill/index.vue"),
            },
            {
              path: "knowledgeBase",
              name: "KnowledgeBase",
              component: () =>
                import("@/view/management/aiService/knowledgeBase/index.vue"),
            },

            //问诊中心
            // {
            //   path: "consultationControl",
            //   name: "ConsultationControl",
            //   component: () =>
            //     import("@/view/management/aiService/consultationControl/index.vue"),
            // },
            //问答记录
            {
              path: "answersRecord",
              name: "AiAnswersRecord",
              component: () =>
                import("@/view/management/aiService/answersRecord/index.vue"),
            },
            //线索表单参数模版配置
            {
              path: "archives",
              name: "AiArchives",
              component: () =>
                import("@/view/management/aiService/archives/index.vue"),
            },
          ],
        },

        /* 公众号模版通知 */
        {
          path: "sendService",
          component: () => import("@/view/management/sendService/index.vue"),
          children: [
            //公众号账户
            {
              path: "sendAccount",
              name: "SendAccount",
              component: () =>
                import("@/view/management/sendService/sendAccount/index.vue"),
            },
            //发送模版配置（包含定时任务的规则）
            {
              path: "sendTemplate",
              name: "SendTemplate",
              component: () =>
                import("@/view/management/sendService/sendTemplate/index.vue"),
            },
            //定时任务-绑定到具体的openid身上
            {
              path: "sendTouserAuto",
              name: "SendTouserAuto",
              component: () =>
                import("@/view/management/sendService/sendTouserAuto/index.vue"),
            },
            //发送记录（手动和自动）
            {
              path: "sendRecord",
              name: "SendRecord",
              component: () =>
                import("@/view/management/sendService/sendRecord/index.vue"),
            },
          ],
        },

        /* 会员余量管理 */
        {
          path: "vipCard",
          name: "MallVipCard",
          component: () => import("@/view/management/vipCard"),
          children: [{
            path: "vipCardList",
            name: "MallVipCardList",
            component: () => import("@/view/management/vipCard/vipCardList"),
          },
          {
            path: "vipCardRecode",
            name: "MallVipCardRecode",
            component: () =>
              import("@/view/management/vipCard/vipCardRecode"),
          },
          {
            path: "myAccount",
            name: "MallMyAccount",
            component: () => import("@/view/management/vipCard/myAccount"),
          },
          ],
        },


        /* api */
        {
          path: "doc",
          // name: "Person",
          component: () => import("@/view/management/doc/index.vue"), //导航
          children: [{
            path: "goods",
            name: "DocGoods",
            component: () =>
              import("@/view/management/doc/goods/index.vue"),
          },],
        },

        /* 个人页 */
        {
          path: "person",
          // name: "Person",
          component: () => import("@/view/management/person/index.vue"), //导航
          children: [{
            path: "center",
            name: "PersonCenter",
            component: () =>
              import("@/view/management/person/center/index.vue"),
          },{
            path: "payment",
            name: "Payment",
            component: () =>
              import("@/view/management/person/payment/index.vue"),
          },],
        },
      ],
    },
    /* 其他页 */
    {
      path: "/errow",
      name: "Errow",
      component: () => import("@/view/error/index.vue"),
    },
  ],
  // mode: "history",
  mode: "hash",
};